import { TmModalComponent } from '@techmore/global';
import { Component, ViewChild } from '@angular/core';
import { MemberPreference, MemberPreferenceOption } from './member-preference';
import { UserService } from 'src/app/share/service/user.service';

@Component({
  selector: 'app-member-preference-modal',
  templateUrl: './member-preference-modal.component.html',
  styleUrls: ['./member-preference-modal.component.scss']
})
export class MemberPreferenceModalComponent {
  @ViewChild('modal', { static: false }) modal: TmModalComponent;

  /** 遠端的會員偏好 */
  oriMemberPreference: MemberPreference;
  /** 用來互動的會員偏好 */
  memberPreference: MemberPreference;

  /** 是否顯示"不再顯示此視窗"。僅系統自己跳出偏好設定時要顯示 */
  showNever = false;

  constructor(
    private service: UserService
  ) {
    this.service.getPreference().subscribe(d => {
      this.oriMemberPreference = Object.assign(new MemberPreference(), d);
      this.oriMemberPreference.subjectSubs = JSON.parse(JSON.stringify(d.subjectSubs))

      this.memberPreference = d;

      if (!d.disablePop && d.subjectSubs.filter(opt => opt.isFavorite).length === 0) {
        this.showNever = true;
        this.open();
      }
    });
  }

  open() {
    this.modal.open();
  }

  close() {
    this.modal.close();
  }

  save() {
    const ref = Object.assign({}, this.memberPreference);
    ref.subjectSubs = this.memberPreference.subjectSubs.filter(opt => opt.isFavorite);
    this.service.updatePreference(ref).subscribe(() => {
      this.oriMemberPreference.subjectSubs = JSON.parse(JSON.stringify(this.memberPreference.subjectSubs));
      this.oriMemberPreference.disablePop = this.memberPreference.disablePop;
      this.close();
    });
  }

  resetData() {
    this.showNever = false;
    this.memberPreference.subjectSubs = JSON.parse(JSON.stringify(this.oriMemberPreference.subjectSubs));
    this.memberPreference.disablePop = this.oriMemberPreference.disablePop;
  }

  trackByFn(i) {
    return i;
  }
}
